import React from 'react';
import { ListFieldSection, PageSection, SectionGroup, FieldSet } from '../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown, IWithWorksheetInjectedProps } from '../../../Core';
import { Field, TextOutput, RadioGroup, Checkbox, Label } from '../../../../Core';
import PlasticLimitTrialSection from './PlasticLimitTrialSection';
import { useSelector } from 'react-redux';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let PlasticLimitSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );
  const llResultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false))
  );

  return (
    <PageSection heading="Plastic Limit">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Rolled By"
          name="PlasticLimit.RolledBy"
          options={[
            { label: 'Hand', value: 'Hand' },
            { label: 'Mechanical Rolling Device', value: 'Mechanical' },
          ]}
        />
      </ListFieldSection>
      <SectionGroup heading="Plastic Limit Determination">
        <NamePrefixModifier appendNamePrefix="PlasticLimit">
          <ListFieldSection>
            <FieldSet>
              <Label>Material Suitability</Label>
              <Field
                input={<Checkbox />}
                label="Result cannot be obtained"
                name="NonPlastic"
                disabled={llResultNotObtainable}
              />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet label="Balance" name="Balance" />
                <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
                <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
              </ListFieldSection>
              <PlasticLimitTrialSection />
            </>
          )}
        </NamePrefixModifier>
      </SectionGroup>

      <ListFieldSection heading="Result">
        {determinationPerformed ? (
          <Field input={<TextOutput />} label="Average Water Content (%)" name="Results.PlasticLimit" />
        ) : (
          <Field input={<TextOutput />} label="Average Water Content (%)" value="N/A" />
        )}
        <Field input={<TextOutput />} label="Plastic Limit" name="Results.PlasticLimitText" />
      </ListFieldSection>
    </PageSection>
  );
};

PlasticLimitSection = withInjectedProps(PlasticLimitSection);

export { PlasticLimitSection };
export default PlasticLimitSection;
